import { Component } from '@verndale/core';
import { isPhoneOnly, isTabletPortraitOnly, isTabletPortraitUp, isTabletLandscapeUp } from '../utils/breakpoints'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $nav: document._$('.primary-nav'),
      $panelWrapper: document._$('.primary-nav-panel-wrapper'),
      $panel: document._$('.primary-nav-panel'),
      $sidePanelClose: this.el._$('.header__side-panel-close'),
      $navTrigger: this.el._$$('.primary-nav__trigger'),
      $panelTablet: document._$('.primary-nav-panel-tablet'),
      $utilitySidePanelClose: document._$('.header__side-panel')._$('.header__side-panel-close'),
      $utilityNav: document._$('.utility-nav'),
      $locationSelectorWrapper: document._$('.location-selector-wrapper')
    };

    this.labels = {
      back: this.dom.$nav.dataset.labelBack,
      mainMenu: this.dom.$nav.dataset.labelMainMenu
    }

    this.template = {
      close: `
        <button class="primary-nav-panel__close" aria-label="Close panel">
          <svg class="primary-nav-panel__close-icon"><use xlink:href="#close" /></svg>
        </button>
      `,
      back: text => `
        <button class="primary-nav-panel__back">
          <svg class="primary-nav-panel__back-icon"><use xlink:href="#arrow-left" /></svg>
          ${text}
        </button>
      `,
      parent: (url, name) => `
        <h2 class="primary-nav-panel__parent-name">
          ${url ? `<a href="${url}">${name}</a>` : name}
        </h2>
      `,
      items: (children, current) => `
        <ul class="primary-nav-children__items">
          ${children.map(({ url, name, children }, i) => `
            <li class="primary-nav-children__item ${current === name ? 'primary-nav-children__item--opened' : ''}" data-index="${i}">
              ${url && (!children || !children.length) ? `
                <a class="primary-nav-children__link" href="${url}">
                  ${name}
                </a>
              ` : `
                <button type="button" class="primary-nav-children__link">
                  ${name}
                </button>
              `}
            </li>
          `).join('')}
        </ul>
      `,
      ad: ad => `
        <${ad.url ? 'a' : 'div'} class="primary-nav-ad" ${ad.url ? `href="${ad.url}"` : ''}>
          ${ad.title ? `<h3 class="primary-nav-ad__title">${ad.title}</h3>` : ''}
          ${ad.description ? `<p class="primary-nav-ad__description">${ad.description}</p>` : ''}
          ${ad.cta ? `<span class="primary-nav-ad__cta link link--with-arrow link--primary">${ad.cta}</span>` : ''}
          ${ad.image ? `<img class="primary-nav-ad__image" src="${ad.image}" alt="">` : ''}
        </${ad.url ? 'a' : 'div'}>
      `
    }
    this.sidePanelExpandedClass = 'header-side-panel-opened';
    this.primaryNavPanelOpenedClass = 'header-primary-nav-panel-opened';
    this.openedPrimaryNavItemClass = 'primary-nav__item--opened';
    this.openedPrimaryNavChildItemClass = 'primary-nav-children__item--opened';
    this.copyPrimaryNavToUtilityNav();
  }

  addListeners() {
    this.dom.$navTrigger._on('click', this.handlePrimaryNavPanelDisplay.bind(this));
    document._$$('.utility-nav__primary-nav-link')._on('click', this.handlePrimaryNavPanelDisplay.bind(this));
    this.dom.$utilitySidePanelClose._on('click', this.handleUtilityNavClose.bind(this));
    document._on('click', this.handleClickOutside.bind(this), false);
  }

  addChildMenuListeners(e) {
    let $container;
    if (isPhoneOnly()) {
      $container = this.dom.$panel;
      $container._$('.primary-nav-panel__back')._on('click', this.handleMainMenuClick.bind(this))
      $container._$('.primary-nav-panel__close')._on('click', this.closeSubNav.bind(this));
    } else if (isTabletPortraitOnly()) {
      $container = this.dom.$panelTablet;
    } else if (isTabletLandscapeUp()) {
      $container = this.dom.$panel._$('.primary-nav-panel__col');
    }

    $container._$$('.primary-nav-children__link[type="button"]')._on('click', this.handlePrimaryNavGrandChildrenDisplay.bind(this));
  }

  addGrandChildMenuListeners(e) {
    if (isPhoneOnly()) {
      this.dom.$panel._$('.primary-nav-panel__back')._on('click', this.renderChildMenu.bind(this))
      this.dom.$panel._$('.primary-nav-panel__close')._on('click', this.closeSubNav.bind(this));
    } else if (isTabletPortraitOnly()) {
      this.dom.$panel._$('.primary-nav-panel__back')._on('click', this.handleMainMenuClick.bind(this))
      this.dom.$panel._$('.header__side-panel-col')._$$('.primary-nav-children__link[type="button"]')._on('click', this.handlePrimaryNavGrandChildrenDisplay.bind(this));
      this.dom.$panel._$('.primary-nav-panel__close')._on('click', this.closeSubNav.bind(this));
    } else {
      this.dom.$panel._$('.primary-nav-panel__col')._$$('.primary-nav-children__link[type="button"]')._on('click', this.handlePrimaryNavGrandChildrenDisplay.bind(this));
    }
  }

  handleUtilityNavClose(e) {
    if (!isTabletPortraitOnly()) return;
    this.closeSubNav(e);
  }

  opensidePanel() {
    document.body.classList.add(this.primaryNavPanelOpenedClass);
    if (isTabletPortraitOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
    }
  }

  closesidePanel(e) {
    if (e.target.getAttribute('id') === 'location-search') return;
    document.body.classList.remove(this.primaryNavPanelOpenedClass);
    document.body.classList.remove(this.sidePanelExpandedClass);
    _$(`.${this.openedPrimaryNavItemClass}`)?.classList?.remove?.(this.openedPrimaryNavItemClass)
  }

  getPrimaryNavTriggerParent(e) {
    return e?.target?.closest?.('.primary-nav__item') || e?.target?.closest?.('.utility-nav__primary-nav-item');
  }

  handlePrimaryNavPanelDisplay(e) {
    const $parent = this.getPrimaryNavTriggerParent(e);
    const isOpen = $parent.classList.contains(this.openedPrimaryNavItemClass);

    if (isPhoneOnly()) {
      isOpen ? this.closeSubNav(e) : this.openSubNav(e);
    } else if (isTabletPortraitUp()) {
      if (!isOpen) this.openSubNav(e);
    }
  }

  openSubNav(e) {
    this.closeSubNav(e);
    const $parent = this.getPrimaryNavTriggerParent(e);
    this.currentNav = JSON.parse($parent.dataset.menu);
    if (!$parent) return;
    if ($parent.classList.contains(this.openedPrimaryNavItemClass)) return;
    $parent.classList.add(this.openedPrimaryNavItemClass);
    this.opensidePanel();
    this.renderChildMenu();
  }

  closeSubNav(e) {
    const $parent = this.getPrimaryNavTriggerParent(e);
    if ($parent) {
      $parent.classList.remove(this.openedPrimaryNavItemClass);
    } else {
      const el = this.el._$(`.${this.openedPrimaryNavItemClass}`);
      if (el) el.classList.remove(this.openedPrimaryNavItemClass)
    }
    this.closesidePanel(e);
  }

  handleClickOutside(e) {
    if (!document.body.classList.contains(this.primaryNavPanelOpenedClass)) return;
    if (e.target.closest('.primary-nav-children__link')) return;
    if (e.target.closest('.primary-nav__back')) return;
    if (e.target.closest('.primary-nav-panel__back')) return;
    if (e.target.closest('.primary-nav__close')) return;
    if (e.target.closest('.primary-nav__item')) return;
    if (e.target.closest('.utility-nav__primary-nav-link')) return;
    if (e.target.closest('.primary-nav-panel')) return;
    if (e.target.closest('.primary-nav-panel-wrapper')) return;
    if (e.target.closest('.location-selector')) return;
    this.closeSubNav(e);
  }

  buildChildMenu() {
    const { children = [] } = this.currentNav;

    if (isPhoneOnly()) {
      return `
          ${this.template.close}
          ${this.template.back(this.labels.mainMenu)}
          ${this.template.parent(this.currentNav.url, this.currentNav.name)}
          ${this.template.items(children)}
      `;
    }

    if (isTabletPortraitOnly()) {
      return `
        ${this.template.parent(this.currentNav.url, this.currentNav.name)}
        ${this.template.items(children)}
      `;
    }

    if (isTabletLandscapeUp()) {
      return `
        <div class="primary-nav-panel__col">
          ${this.template.parent(this.currentNav.url, this.currentNav.name)}
          ${this.template.items(children)}
        </div>
        ${this.currentNav.ad ? `
        <div class="primary-nav-panel__col primary-nav__ad-wrapper">
          ${this.template.ad(this.currentNav.ad)}
        </div>
        ` : ''}
      `;
    }
  }

  renderChildMenu() {
    let $container;

    if (isPhoneOnly() || isTabletLandscapeUp()) {
      $container = this.dom.$panel;
    } else if (isTabletPortraitOnly()) {
      $container = this.dom.$panelTablet;
    }

    $container.innerHTML = this.buildChildMenu();
    this.addChildMenuListeners();

    if (isTabletLandscapeUp()) {
      this.positionNav();
    }
  }

  handleMainMenuClick(e) {
    this.closeSubNav(e);
    if (isPhoneOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
    } else if (isTabletPortraitOnly()) {
      document.body.classList.add(this.sidePanelExpandedClass);
      document.body.classList.add(this.primaryNavPanelOpenedClass);
    }
  }

  handlePrimaryNavGrandChildrenDisplay(e) {
    const $parent = e.currentTarget.closest('.primary-nav-children__item');
    const menu = this.currentNav.children[parseInt($parent.dataset.index)];
    this.currentChildNav = menu;
    this.renderGrandChildMenu();
  }

  buildGrandChildMenu() {
    const { children = [] } = this.currentChildNav;

    if (isPhoneOnly()) {
      return `
        ${this.template.close}
        ${this.template.back(this.labels.back)}
        ${this.template.parent(this.currentChildNav.url, this.currentChildNav.name)}
        ${this.template.items(children)}
      `;
    }

    if (isTabletPortraitOnly()) {
      return `
        ${this.template.close}
        <div class="header__side-panel-cols">
          <div class="header__side-panel-col">
            ${this.template.back(this.labels.mainMenu)}
            ${this.template.parent(this.currentNav.url, this.currentNav.name)}
            ${this.template.items(this.currentNav.children, this.currentChildNav.name)}
          </div>
          <div class="header__side-panel-col">
            ${this.template.parent(this.currentChildNav.url, this.currentChildNav.name)}
            ${this.template.items(children)}
          </div>
        </div>
      `
    }

    if (isTabletLandscapeUp()) {
      const { ad = this.currentNav.ad } = this.currentChildNav;

      return `
        <div class="primary-nav-panel__col">
          ${this.template.parent(this.currentNav.url, this.currentNav.name)}
          ${this.template.items(this.currentNav.children, this.currentChildNav.name)}
        </div>
        <div class="primary-nav-panel__col">
          ${this.template.parent(this.currentChildNav.url, this.currentChildNav.name)}
          ${this.template.items(children)}
        </div>
        ${ad ? `
        <div class="primary-nav-panel__col primary-nav__ad-wrapper">
          ${this.template.ad(ad)}
        </div>
        ` : ''}
      `;
    }
  }

  renderGrandChildMenu() {
    this.dom.$panel.innerHTML = this.buildGrandChildMenu(this.currentChildNav);
    this.addGrandChildMenuListeners();

    if (isTabletPortraitOnly()) {
      document.body.classList.remove(this.sidePanelExpandedClass);
    } else if (isTabletLandscapeUp()) {
      this.positionNav();
    }
  }

  handleBackClick() {
    this.renderChildMenu();
  }

  positionNav() {
    const $current = this.dom.$nav._$(`.${this.openedPrimaryNavItemClass}`);
    if (!$current) return;
    const leftEdge = this.dom.$nav.offsetLeft;
    const { width: itemWidth } = $current.getClientRects()[0];
    const { width: panelWidth } = this.dom.$panelWrapper.getClientRects()[0];
    const itemLeftOffset = $current.offsetLeft;
    const itemCenter = (itemWidth / 2) + itemLeftOffset;
    const panelCenter = panelWidth / 2;
    let panelLeftOffset = itemCenter - panelCenter;

    if (panelLeftOffset < leftEdge) panelLeftOffset = leftEdge - 20;

    this.dom.$panelWrapper.style.left = `${panelLeftOffset}px`;
  }

  copyPrimaryNavToUtilityNav() {
    this.dom.$navTrigger.forEach(nav => {
      const $parent = nav.closest('.primary-nav__item');
      const $item = $parent.cloneNode(true);
      const $trigger = $item._$('.primary-nav__trigger');

      $item.classList.remove('primary-nav__item');
      $item.classList.add('header__side-panel-item');
      $item.classList.add('utility-nav__primary-nav-item');
      $trigger.classList.remove('primary-nav__trigger');
      $trigger.classList.add('header__side-panel-link');
      $trigger.classList.add('utility-nav__primary-nav-link');

      this.dom.$utilityNav.insertBefore($item, this.dom.$locationSelectorWrapper);
    })
  }
}

export default Module;
